module.exports = {
          srcSet: __webpack_public_path__ + "0f8438522d53988de251ee31d8efac8c-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "0f8438522d53988de251ee31d8efac8c-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "0f8438522d53988de251ee31d8efac8c-24.png",
          toString:function(){return __webpack_public_path__ + "0f8438522d53988de251ee31d8efac8c-24.png"},
          
          width: 24,
          height: 24
        }